<ng-container *ngIf="{ state: costUnitCostState$ | async, sharedDataState: sharedDataState$ | async } as s">
    <div class="cost-unit-cost-container mat-elevation-z8">
        <div class="cost-unit-cost-table-header">
            <span class="costAccountingSelection">
                <mat-generic-select-input [inputFormControl]="costAccountingFormControl"
                                          [field]="layout.costAccountingSelection"></mat-generic-select-input>
            </span>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="s.state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <mat-tab-group [selectedIndex]="activeTab$ | async" (selectedIndexChange)="onChangeTab($event)" mat-align-tabs="center">
            <mat-tab>
                <ng-template mat-tab-label>{{ "app.page.analytics.cost-unit-cost.label" | translate }}</ng-template>
                <ng-template matTabContent>
                    <div class="content">
                        <div class="costUnitCostingLevelCost">

                            <div class="selection">
                                <span>{{ "app.page.cost-unit-cost.cost-unit-selection.label" | translate }}: </span>
                                <span style="width: 60%">
                        <mat-generic-select-input [inputFormControl]="costUnitFormControl" [field]="layout.costUnitSelection"></mat-generic-select-input>
                    </span>
                            </div>
                            <table>

                                <tr class="tableHeaderRow">
                                    <th class="tableHeaderCell"></th>
                                    <th class="tableHeaderCell alignRight">{{ "app.page.cost-unit-cost.cost.label" | translate }}</th>
                                    <th class="tableHeaderCell alignRight">{{ "app.page.cost-unit-cost.cost.label" | translate }} /

                                        {{ s.sharedDataState.measureUnitLookup[s.sharedDataState.costUnitLookup[costUnitFormControl.value]?.baseMeasureUnitId]?.shortName }}

                                    </th>
                                </tr>

                                <ng-template #nodeTemplateRef let-costingLevel="costingLevel" let-depth="depth" let-childIndex="childIndex">

                                    <ng-container *ngIf="depth === 0; else preOrderTraversal">
                                        <ng-container *ngTemplateOutlet="recursion"></ng-container>
                                        <ng-container *ngTemplateOutlet="rowCost"></ng-container>
                                    </ng-container>

                                    <ng-template #preOrderTraversal>
                                        <ng-container *ngTemplateOutlet="rowCost"></ng-container>
                                        <ng-container *ngTemplateOutlet="recursion"></ng-container>
                                    </ng-template>

                                    <ng-template #recursion>
                                        <ng-template ngFor let-child [ngForOf]="costingLevel.children" let-childIndex="index">
                                            <!-- Invoke the recursive template. Increment depth for each recursion.-->
                                            <ng-template
                                                [ngTemplateOutlet]="nodeTemplateRef"
                                                [ngTemplateOutletContext]="{ costingLevel: child, depth: depth + 1, childIndex: childIndex }">
                                            </ng-template>

                                        </ng-template>
                                    </ng-template>


                                    <ng-template #rowCost>
                                        <tr class="tableRow" [class.primary-level]="depth === 0">
                                            <td class="tableCell" [style.padding-left.px]="depth * 40 + 10">
                                                <span *ngIf="childIndex !== 0 && depth == 1"> + </span>
                                                <span *ngIf="costingLevel.children.length >0 && depth == 0">= </span>
                                                <span>

                                                    @if (!costingLevel.other) {
                                                        {{ costingLevel.name }}
                                                    } @else {
                                                        {{ "app.model.costing-level.other.label" | translate }}
                                                    }

                                                </span>
                                            </td>
                                            <td class="tableCell alignRight">
                                                <ng-container *ngIf="s.state.costUnitCostingLevelCostMap[costingLevel.id]?.costCt != null; else noCost">
                                                    {{ (s.state.costUnitCostingLevelCostMap[costingLevel.id].costCt / 100) | currency:'EUR':'symbol':'1.2-2' }}
                                                </ng-container>
                                            </td>
                                            <td class="tableCell alignRight">
                                                <ng-container *ngIf="s.state.costUnitCostingLevelCostMap[costingLevel.id]?.costCtPerMeasureUnit != null; else noCost">
                                                    {{ (s.state.costUnitCostingLevelCostMap[costingLevel.id].costCtPerMeasureUnit / 100) | currency:'EUR':'symbol':'1.2-2' }}
                                                </ng-container>
                                            </td>
                                            <ng-template #noCost>-</ng-template>
                                        </tr>
                                    </ng-template>

                                </ng-template>

                                <!-- Initiate the recursive template rendering. -->
                                <ng-container
                                    *ngFor="let rootCostingLevel of s.sharedDataState.costingLevelTree"
                                    [ngTemplateOutlet]="nodeTemplateRef"
                                    [ngTemplateOutletContext]="{ costingLevel: rootCostingLevel, depth: 0 }">
                                </ng-container>

                                <!-- Sum Row  -->
                                <tr class="tableRow sumRow">
                                    <td class="tableCell">
                                        {{ "app.page.cost-unit-cost.primary-cost.label"| translate }}
                                    </td>
                                    <td class="tableCell alignRight">
                                        {{ (costSum / 100) | currency:'EUR':'symbol':'1.2-2' }}
                                    </td>
                                    <td class="tableCell alignRight">
                                        {{ (costSumPerMeasureUnit / 100) | currency:'EUR':'symbol':'1.2-2' }}
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <mat-divider vertical="true"></mat-divider>

                        <div class="costUnitCostComparison">
                            <div class="selection">
                                <span>{{ "app.page.cost-unit-cost.costingLevel-selection.label" | translate }}: </span>
                                <mat-generic-input [fields]="layout.graphFilterSelection" [(inputFormGroup)]="graphFilterFormGroup"></mat-generic-input>
                            </div>
                            <canvas
                                baseChart
                                height="200"
                                [data]="chartData"
                                [legend]="layout.chartConfig.legend"
                                [type]="layout.chartConfig.chartType"
                                [options]="layout.chartConfig.chartOptions"
                            >
                            </canvas>

                        </div>

                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>{{ "app.page.analytics.contribution-margins.label" | translate }}</ng-template>
                <ng-template matTabContent>
                    <app-break-even-list [costAccountingId]="costAccountingFormControl.value"></app-break-even-list>
                </ng-template>
            </mat-tab>
        </mat-tab-group>


    </div>
</ng-container>
